const ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

export function newDossierReference() {
  const d = new Date();
  const ymd =
    String(d.getFullYear()).slice(2) +
    String(d.getMonth() + 1).padStart(2, "0") +
    String(d.getDate()).padStart(2, "0");
  const bytes = new Uint8Array(4);
  crypto.getRandomValues(bytes);
  let suffix = "";
  bytes.forEach((b) => {
    suffix += ALPHABET[b % ALPHABET.length];
  });
  return `HI-${ymd}-${suffix}`;
}
